import AxiosClient from '../../../shared/infrastructure/services/axios.client';
import { AuthService } from './auth/auth.service';
import UserService from './user/user.service';

const authService = new AuthService();
const client = new AxiosClient();
const userService = new UserService(authService, client, localStorage);

export { authService, userService };
